export const STATUS = {
  student: { active: '在读', leave: '请假中', suspended: '停托', graduated: '毕业' },
  attendance: { not_arrived: '未签到', checked_in: '已签到', checked_out: '已签退', leave: '请假' },
  leave: { pending: '待审批', approved: '已通过', rejected: '已拒绝', cancelled: '已取消' },
  payment: { pending: '待支付', paid: '已支付', overdue: '欠费', cancelled: '已取消', refunded: '已退款' },
  notice: { draft: '草稿', published: '已发布', revoked: '已撤回' },
  feedback: { pending: '待反馈', completed: '已反馈' },
  user: { active: '启用中', disabled: '已禁用' },
  class: { active: '正常', disabled: '已停用' }
}

export const ROLE_LABELS = { super_admin: '超级管理员', principal: '校长', campus_admin: '校区管理员', teacher: '老师' }

export function labelOf(group, value) { return STATUS[group]?.[value] || value || '--' }

export function typeOfStatus(value) {
  if (['在读', '已签到', '已签退', '已通过', '已反馈', '已发布', '已支付', '启用中', '正常'].includes(value)) return 'success'
  if (['待审批', '待反馈', '待支付', '欠费', '草稿', '未签到', '请假中'].includes(value)) return 'warning'
  if (['停托', '已拒绝', '已撤回', '已禁用', '已停用', '已取消', '已退款'].includes(value)) return 'danger'
  return 'info'
}
